// extracted by mini-css-extract-plugin
export default {"fieldList":"AutoForm_fieldList__42C7a"};